var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '../Button';
import Divider from '../Divider';
import Text from '../Text';
import { DateRange } from 'react-date-range';
import colors from '../../themes/colors';
import { ButtonGroup, DatePickerCalendarContainer, DatePickerCalendarLabels, DatePickerCalendarWrapper, } from './DatePicker.CalendarWrappers';
import { formatSelectedDateRange } from './formatSelectedDateRange';
var DatePickerCalendar = function (props) {
    var maxDate = props.maxDate, rangeKey = props.rangeKey, ranges = props.ranges, onRangeChange = props.onRangeChange, onDateRangeSubmit = props.onDateRangeSubmit, onCloseDatePicker = props.onCloseDatePicker;
    var onDefinedRangeChange = function (selection) {
        if (onRangeChange)
            onRangeChange(selection[rangeKey]);
    };
    var onButtonClick = function (method) { return function (event) {
        event === null || event === void 0 ? void 0 : event.preventDefault();
        event === null || event === void 0 ? void 0 : event.stopPropagation();
        method();
    }; };
    return (_jsxs(DatePickerCalendarContainer, { children: [_jsx(DatePickerCalendarWrapper, { children: _jsx(DateRange, { showMonthAndYearPickers: false, months: 2, direction: "horizontal", ranges: ranges, onChange: onDefinedRangeChange, color: colors.bigBangBlack, showDateDisplay: false, monthDisplayFormat: "MMMM yyyy", weekdayDisplayFormat: "EEEEE", rangeColors: [colors.bigBangBlack], startDatePlaceholder: "Today", endDatePlaceholder: "Tomorrow", maxDate: maxDate, fixedHeight: true }) }), _jsx(Divider, { margin: 0 }), _jsxs(ButtonGroup, { children: [_jsxs(DatePickerCalendarLabels, { children: [_jsx(Text, __assign({ variant: "body2Semibold", color: "bigBangBlack" }, { children: formatSelectedDateRange(ranges[0]) })), _jsx(Text, __assign({ variant: "body3", color: "neutral60" }, { children: "Eastern Time" }))] }), _jsx(Button, { size: "small", label: "Cancel", onClick: onButtonClick(onCloseDatePicker), variant: "outlined" }), _jsx(Button, { size: "small", label: "Update", onClick: onButtonClick(onDateRangeSubmit) })] })] }));
};
export default DatePickerCalendar;
